// extracted by mini-css-extract-plugin
export var container = "about-module--container--d0702";
export var contentWrapper = "about-module--content-wrapper--3220b";
export var diseaseCopy = "about-module--disease-copy--fa29c";
export var italic = "about-module--italic--524f0";